<template>
  <!--
      	作者：gmshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-页面背景图
      -->
  <div class="test-wrap mt30">
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="单人项目限制次数" prop="limit_count" :rules="[{ required: true, message: '请输入每天单人项目限制次数' }]">
        <el-input v-model="form.limit_count" placeholder="请输入单人项目限制次数" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="单人活动图片">
        <el-button type="primary" plain icon="el-icon-upload" @click="openUpload(1)">上传图片</el-button>
        <div v-if="form.solo != ''" class="img"><img :src="form.solo" width="400" height="227" /></div>
        <div class="tips">尺寸：宽750像素 高度450像素</div>
      </el-form-item>
      <el-form-item label="团队活动图片">
        <el-button type="primary" plain icon="el-icon-upload" @click="openUpload(2)">上传图片</el-button>
        <div v-if="form.team != ''" class="img"><img :src="form.team" width="400" height="227" /></div>
        <div class="tips">尺寸：宽750像素 高度450像素</div>
      </el-form-item>
      <el-form-item label="打卡视频默认封面图片">
        <el-button type="primary" plain icon="el-icon-upload" @click="openUpload(3)">上传图片</el-button>
        <div v-if="form.clock != ''" class="img"><img :src="form.clock" width="400" height="227" /></div>
        <div class="tips">尺寸：宽750像素 高度450像素</div>
      </el-form-item>
      <el-form-item label="单人活动介绍  ">
        <el-input v-model="form.solo_dec" type="textarea" rows="5" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="团队活动介绍  ">
        <el-input v-model="form.team_dec" type="textarea" rows="5" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
import TaskApi from '@/api/task.js';
export default {
  components: {
    Upload: Upload
  },
  data() {
    return {
      form: {
        limit_count:3,
        solo: '',
        team: '',
        solo_dec: '',
        team_dec: '',
        clock:'',
        clock_image_id:""
      },
      /*是否上传图片*/
      isupload: false,
       /*是否正在加载*/
      loading: false,
       /*图片类别*/
      type: ''
    };
  },
  props:{
    settingData:Object
  },
  created() {
    this.getData();
  },

  methods: {
    getData(){
      let self = this;
      self.loading = true;

      TaskApi.toSettingTask({}, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        if (this.type == 1) {
          this.form.solo = e[0].file_path;
        }
        if (this.type == 2) {
          this.form.team = e[0].file_path;
        }
        if (this.type == 3) {
          this.form.clock = e[0].file_path;
          this.form.clock_image_id = e[0].file_id;
        }

      }
      this.isupload = false;
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      TaskApi.settingTask(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }

  }
};
</script>

<style lang="scss">
.test-wrap {
  padding: 30px;
}

.img {
  margin-top: 10px;
}

.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/task/task/setting.vue